// extracted by mini-css-extract-plugin
module.exports = {"btns":"Button_btns__3EKaC","btns--border":"Button_btns--border__4KAS3","btns--borderless":"Button_btns--borderless__2W36a","ant-btn-disabled":"Button_ant-btn-disabled__3iUx-"};